/**
 * @module tools/EventCoordinator
 */
import each from 'lodash/each';

import Logger from '../tools/Logger';

const log = Logger.child({ component: 'EventCoordinator' }, true);

const _handlers = Symbol();
export default class EventCoordinator {
  constructor() {
    this[_handlers] = new WeakMap();
  }
  onOnly(target, eventName, handler) {
    if (!target || !target.addEventListener || !target.removeEventListener) {
      throw new Error('EventCoordinator.onOnly target, must be an EventTarget');
    }
    let handlers;
    if (!this[_handlers].has(target)) {
      handlers = {};
      this[_handlers].set(target, handlers);
    } else handlers = this[_handlers].get(target);
    if (handlers[eventName]) {
      // Not going to throw an error, just going to implement fallback logic.
      log.debug(
        'Should not bind multiple handlers to same target and event, will evict previous event handler for the new one',
      );
      this.offOnly(target, eventName);
    }
    handlers[eventName] = handler;
    target.addEventListener(eventName, handler, false);
  }
  offOnly(target, eventName) {
    // no need to check type here, if we don't have an entry that says enough
    const handlers = this[_handlers].get(target);
    const fn = handlers && handlers[eventName];
    if (!handlers || !fn) {
      // for debugging purposes only
      log.debug({ target }, `Could not find handler to remove for event: ${eventName}`);
      return;
    }
    target.removeEventListener(eventName, fn, false);
    delete handlers[eventName];
  }

  /*
   * Removes all events coordinated by this instance from target
   */
  offAll(target) {
    const handlers = this[_handlers].get(target);
    if (!handlers) {
      log.debug({ target }, 'Could not find handlers to remove from target.');
      return;
    }

    each(handlers, (fn, eventName) => {
      target.removeEventListener(eventName, fn, false);
      delete handlers[eventName];
    });
  }
}
